import logo_name from "../../assets/imgs/logo_name.png";
import { IoClose, IoMenu } from "react-icons/io5";
import { Container } from "../../assets/styles/Container";
import { HeaderStyled } from "./styles";
import { ButtonNav } from "./components/ButtonNav/buttonNav";
import { ModalRegisterHeader } from "./components/ModalRegister/register";
import { ModalLoginHeader } from "./components/ModalLogin/login";
import { useContext, useState } from "react";
import { UserContext } from "../../providers/UserContext";
import { ButtonStyled } from "../Button/styles";
import { Link } from "react-router-dom";
import { ModalConfirmTerm } from "./components/ModalTerm/term";

export const Header = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  const { user, userLogout, isTermAccepted, setIsTermAccepted } = useContext(UserContext);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <HeaderStyled>
      <Container>
        <div className="container">
          <div className="logo">
            <Link to="/ultimas">
              <img src={logo_name} alt="Logo do mungango" />
            </Link>
          </div>

          <nav className="navbar">
            <abbr title="Ultimas">
              <Link to="/ultimas">Ultimas</Link>
            </abbr>
            <abbr title="">
              <Link to="/mungangos">Mungangos</Link>
            </abbr>
            <abbr title="">
              <Link to="/top">Top</Link>
            </abbr>

            {!user ? (
              <div className="btn">
                <abbr title="Login">
                  <ButtonNav
                    $backgroundColor="--color-brand-0"
                    $color="--color-white-fixed"
                    showModal={() => {
                      setShowLogin(true);
                    }}
                  >
                    Login
                  </ButtonNav>
                </abbr>
                <abbr title="Cadastrar">
                  <ButtonNav
                    $backgroundColor="--color-brand-5"
                    $color="--color-white-fixed"
                    showModal={() => {
                      setShowRegister(true);
                    }}
                  >
                    Cadastrar
                  </ButtonNav>
                </abbr>
              </div>
            ) : (
              <div className="perfil-container">
                <div className="perfil-exemple">
                  <Link to={`/perfil/${user?.username}`}>
                    <img src={user?.image} alt="exemplo de perfil" />
                  </Link>
                </div>
                <ButtonStyled onClick={userLogout}>Sair</ButtonStyled>
              </div>
            )}
          </nav>
          <div id="burger">
            {!isMobileMenuOpen ? (
              <IoMenu
                size={"35px"}
                onClick={() => {
                  setIsMobileMenuOpen(!isMobileMenuOpen);
                }}
              />
            ) : (
              <IoClose
                size={"35px"}
                onClick={() => {
                  setIsMobileMenuOpen(!isMobileMenuOpen);
                }}
              />
            )}
          </div>
          {isMobileMenuOpen && (
            <nav className="hamburguer-nav">
              <div className="hamburguer-navbar">
                <abbr title="Ultimas">
                  <Link to="/ultimas">Ultimas</Link>
                </abbr>
                <abbr title="">
                  <Link to="/mungangos">Mungangos</Link>
                </abbr>
                <abbr title="">
                  <Link to="/top">Top</Link>
                </abbr>
                {!user ? (
                  <div className="btn">
                    <abbr title="Login">
                      <ButtonNav
                        $backgroundColor="--color-brand-0"
                        $color="--color-white-fixed"
                        showModal={() => {
                          setShowLogin(true);
                        }}
                      >
                        Login
                      </ButtonNav>
                    </abbr>
                    <abbr title="Cadastrar">
                      <ButtonNav
                        $backgroundColor="--color-brand-5"
                        $color="--color-white-fixed"
                        showModal={() => {
                          setShowRegister(true);
                        }}
                      >
                        Cadastrar
                      </ButtonNav>
                    </abbr>
                  </div>
                ) : (
                  <div className="perfil-container">
                    <div className="perfil-exemple">
                      <Link to={`/perfil/${user?.username}`}>
                        <img src={user?.image} alt="exemplo de perfil" />
                      </Link>
                    </div>
                    <ButtonStyled onClick={userLogout}>Sair</ButtonStyled>
                  </div>
                )}
              </div>
            </nav>
          )}
        </div>
      </Container>
      <ModalLoginHeader showLogin={showLogin} setShowLogin={setShowLogin} />

      <ModalRegisterHeader
        showRegister={showRegister}
        setShowRegister={setShowRegister}
      />

      <ModalConfirmTerm
        showConfirmTerm={isTermAccepted}
        setShowConfirmTerm={setIsTermAccepted}
      />


    </HeaderStyled>
  );
};
